import React from 'react';
import { Button } from 'antd';
import { useTranslation } from "react-i18next";
import styles from "./Volunteer.module.scss";
import FFKLogo from "../../assets/images/ffk-logo-sm.png";

interface StepOneProps {
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
}

const StepOne: React.FC<StepOneProps> = ({ setCurrentStep }) => {
  const { t } = useTranslation();
  return (
      <div className={styles.StepOneContainer}>
        <img src={FFKLogo} alt="FFK Logo"/>
        <h1>{t("app.volunteers.title")}</h1>
        <p>{t("app.volunteers.stepOne.p1")}</p>
        <br />
        <p>{t("app.volunteers.stepOne.p2")}</p>

        {/* Button to go to VolunteerForm */}
        <div className={styles.ButtonAlignment}>
        <Button
            type="primary"
            onClick={() => setCurrentStep(1)}
            className={styles.ButtonStyle}
        >
          {t("app.volunteers.stepOne.continue")}
        </Button>
        </div>
      </div>
  );
};

export default StepOne;
